var _path, _rect, _rect2, _rect3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect4, _circle, _line, _rect5, _rect6, _rect7, _circle2, _line2, _rect8, _rect9, _rect10, _circle3, _line3, _rect11, _rect12, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _rect13, _rect14, _rect15, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _rect16, _circle4, _line4, _rect17, _rect18, _rect19, _circle5, _line5, _rect20, _rect21, _rect22, _circle6, _line6, _rect23, _rect24, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _rect25, _rect26, _rect27, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _rect28, _circle7, _line7, _rect29, _rect30, _rect31, _circle8, _line8, _rect32, _rect33, _rect34, _circle9, _line9, _rect35, _rect36, _path48, _path49, _path50, _path51, _path52, _path53, _line10, _line11, _line12, _line13, _path54, _path55, _path56, _path57;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThirdMachinePopup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 608,
    height: 279,
    viewBox: "0 0 608 279",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H608V279H0V0Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 69,
    width: 22,
    height: 24,
    fill: "white",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 69,
    width: 26,
    height: 10,
    fill: "white",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 83,
    width: 26,
    height: 10,
    fill: "white",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M313 73V75.21",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M313 87V89.21",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M309 73V75.21",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M309 87V89.21",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M305 73V75.21",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M305 87V89.21",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M301 87V89.21",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M297 87V89.21",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M299 76C300.105 76 301 75.1046 301 74C301 72.8954 300.105 72 299 72C297.895 72 297 72.8954 297 74C297 75.1046 297.895 76 299 76Z",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 243,
    y: 173,
    width: 30,
    height: 20,
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 182,
    r: 2,
    stroke: "#C1C1C1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 244.5,
    y1: 190.5,
    x2: 271.5,
    y2: 190.5,
    stroke: "#C1C1C1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 273,
    y: 191,
    width: 2,
    height: 2,
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 241,
    y: 191,
    width: 2,
    height: 2,
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 243,
    y: 203,
    width: 30,
    height: 20,
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 212,
    r: 2,
    stroke: "#C1C1C1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 244.5,
    y1: 220.5,
    x2: 271.5,
    y2: 220.5,
    stroke: "#C1C1C1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 273,
    y: 221,
    width: 2,
    height: 2,
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 241,
    y: 221,
    width: 2,
    height: 2,
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 243,
    y: 233,
    width: 30,
    height: 20,
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 242,
    r: 2,
    stroke: "#C1C1C1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 244.5,
    y1: 250.5,
    x2: 271.5,
    y2: 250.5,
    stroke: "#C1C1C1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 273,
    y: 251,
    width: 2,
    height: 2,
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 241,
    y: 251,
    width: 2,
    height: 2,
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M229.26 139L230.748 130.469H231.809L230.32 139H229.26ZM231.457 139L232.951 130.469H234.012L232.518 139H231.457ZM234.885 133.896H228.785V132.906H234.885V133.896ZM234.439 136.598H228.346V135.613H234.439V136.598ZM239.812 130.451V139H238.125V132.396L236.098 133.041V131.711L239.631 130.451H239.812Z",
    fill: "#C1C1C1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M258.5 81V80C257.948 80 257.5 80.4477 257.5 81H258.5ZM257.793 107.707C258.183 108.098 258.817 108.098 259.207 107.707L265.571 101.343C265.962 100.953 265.962 100.319 265.571 99.9289C265.181 99.5384 264.547 99.5384 264.157 99.9289L258.5 105.586L252.843 99.9289C252.453 99.5384 251.819 99.5384 251.429 99.9289C251.038 100.319 251.038 100.953 251.429 101.343L257.793 107.707ZM286.5 80H258.5V82H286.5V80ZM257.5 81V107H259.5V81H257.5Z",
    fill: "#878787"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M282.793 244.207C282.402 243.817 282.402 243.183 282.793 242.793L289.157 236.429C289.547 236.038 290.181 236.038 290.571 236.429C290.962 236.819 290.962 237.453 290.571 237.843L284.914 243.5L290.571 249.157C290.962 249.547 290.962 250.181 290.571 250.571C290.181 250.962 289.547 250.962 289.157 250.571L282.793 244.207ZM304 243.5H305C305 244.052 304.552 244.5 304 244.5V243.5ZM304 181.5V180.5C304.552 180.5 305 180.948 305 181.5H304ZM304 244.5H283.5V242.5H304V244.5ZM283.5 180.5H304V182.5H283.5V180.5ZM305 181.5V243.5H303V181.5H305Z",
    fill: "#4DBB5F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M249 146L267 146L267 129.414C267 129.149 266.895 128.895 266.707 128.707L262.586 124.586C262.211 124.211 261.702 124 261.172 124L250 124C249.448 124 249 124.448 249 125L249 146Z",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M262 129L262 125L266 129L262 129Z",
    fill: "#C1C1C1",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M261 153V143H267V153L264 150L261 153Z",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M263.117 135.659C263.493 134.952 264.507 134.952 264.883 135.659L265.09 136.049C265.331 136.5 265.873 136.698 266.347 136.506L266.757 136.341C267.5 136.041 268.276 136.692 268.11 137.476L268.018 137.908C267.912 138.408 268.2 138.908 268.687 139.066L269.107 139.203C269.869 139.451 270.044 140.449 269.414 140.942L269.065 141.214C268.663 141.529 268.562 142.097 268.833 142.531L269.067 142.906C269.491 143.586 268.985 144.463 268.184 144.435L267.743 144.42C267.232 144.402 266.79 144.773 266.718 145.28L266.656 145.717C266.545 146.51 265.593 146.857 264.997 146.321L264.669 146.026C264.289 145.684 263.711 145.684 263.331 146.026L263.003 146.321C262.407 146.857 261.455 146.51 261.344 145.717L261.282 145.28C261.21 144.773 260.768 144.402 260.257 144.42L259.816 144.435C259.015 144.463 258.509 143.586 258.933 142.906L259.167 142.531C259.438 142.097 259.337 141.529 258.935 141.214L258.586 140.942C257.956 140.449 258.131 139.451 258.893 139.203L259.313 139.066C259.8 138.908 260.088 138.408 259.982 137.908L259.89 137.476C259.724 136.692 260.5 136.041 261.243 136.341L261.653 136.506C262.127 136.698 262.669 136.5 262.91 136.049L263.117 135.659Z",
    fill: "#4DBB5F",
    stroke: "#4DBB5F",
    strokeWidth: 2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 69,
    width: 22,
    height: 24,
    fill: "white",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 69,
    width: 26,
    height: 10,
    fill: "white",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 83,
    width: 26,
    height: 10,
    fill: "white",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M105 73V75.21",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M105 87V89.21",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M101 73V75.21",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M101 87V89.21",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M97 73V75.21",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M97 87V89.21",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M93 87V89.21",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M89 87V89.21",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M91 76C92.1046 76 93 75.1046 93 74C93 72.8954 92.1046 72 91 72C89.8954 72 89 72.8954 89 74C89 75.1046 89.8954 76 91 76Z",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 203,
    width: 30,
    height: 20,
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 212,
    r: 2,
    stroke: "#C1C1C1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 36.5,
    y1: 220.5,
    x2: 63.5,
    y2: 220.5,
    stroke: "#C1C1C1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 221,
    width: 2,
    height: 2,
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 221,
    width: 2,
    height: 2,
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 173,
    width: 30,
    height: 20,
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 182,
    r: 2,
    stroke: "#C1C1C1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 36.5,
    y1: 190.5,
    x2: 63.5,
    y2: 190.5,
    stroke: "#C1C1C1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 191,
    width: 2,
    height: 2,
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 191,
    width: 2,
    height: 2,
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 173,
    width: 30,
    height: 20,
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 182,
    r: 2,
    stroke: "#C1C1C1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 131.5,
    y1: 190.5,
    x2: 158.5,
    y2: 190.5,
    stroke: "#C1C1C1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 191,
    width: 2,
    height: 2,
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 191,
    width: 2,
    height: 2,
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M136 146L154 146L154 129.414C154 129.149 153.895 128.895 153.707 128.707L149.586 124.586C149.211 124.211 148.702 124 148.172 124L137 124C136.448 124 136 124.448 136 125L136 146Z",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M149 129L149 125L153 129L149 129Z",
    fill: "#C1C1C1",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M148 153V143H154V153L151 150L148 153Z",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M150.117 135.659C150.493 134.952 151.507 134.952 151.883 135.659L152.09 136.049C152.331 136.5 152.873 136.698 153.347 136.506L153.757 136.341C154.5 136.041 155.276 136.692 155.11 137.476L155.018 137.908C154.912 138.408 155.2 138.908 155.687 139.066L156.107 139.203C156.869 139.451 157.044 140.449 156.414 140.942L156.065 141.214C155.663 141.529 155.562 142.097 155.833 142.531L156.067 142.906C156.491 143.586 155.985 144.463 155.184 144.435L154.743 144.42C154.232 144.402 153.79 144.773 153.718 145.28L153.656 145.717C153.545 146.51 152.593 146.857 151.997 146.321L151.669 146.026C151.289 145.684 150.711 145.684 150.331 146.026L150.003 146.321C149.407 146.857 148.455 146.51 148.344 145.717L148.282 145.28C148.21 144.773 147.768 144.402 147.257 144.42L146.816 144.435C146.015 144.463 145.509 143.586 145.933 142.906L146.167 142.531C146.438 142.097 146.337 141.529 145.935 141.214L145.586 140.942C144.956 140.449 145.131 139.451 145.893 139.203L146.313 139.066C146.8 138.908 147.088 138.408 146.982 137.908L146.89 137.476C146.724 136.692 147.5 136.041 148.243 136.341L148.653 136.506C149.127 136.698 149.669 136.5 149.91 136.049L150.117 135.659Z",
    fill: "#4DBB5F",
    stroke: "#4DBB5F",
    strokeWidth: 2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M41 146L59 146L59 129.414C59 129.149 58.8946 128.895 58.7071 128.707L54.5858 124.586C54.2107 124.211 53.702 124 53.1716 124L42 124C41.4477 124 41 124.448 41 125L41 146Z",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M54 129L54 125L58 129L54 129Z",
    fill: "#C1C1C1",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M53 153V143H59V153L56 150L53 153Z",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1173 135.659C55.4935 134.952 56.5065 134.952 56.8827 135.659L57.0904 136.049C57.3307 136.5 57.873 136.698 58.3474 136.506L58.7572 136.341C59.4998 136.041 60.2758 136.692 60.1097 137.476L60.018 137.908C59.9118 138.408 60.2004 138.908 60.6868 139.066L61.1071 139.203C61.8685 139.451 62.0444 140.449 61.4136 140.942L61.0655 141.214C60.6625 141.529 60.5623 142.097 60.8332 142.531L61.0672 142.906C61.4913 143.586 60.9848 144.463 60.1845 144.435L59.7428 144.42C59.2316 144.402 58.7895 144.773 58.7181 145.28L58.6564 145.717C58.5446 146.51 57.5927 146.857 56.9974 146.321L56.6688 146.026C56.2886 145.684 55.7114 145.684 55.3312 146.026L55.0026 146.321C54.4073 146.857 53.4554 146.51 53.3436 145.717L53.2819 145.28C53.2105 144.773 52.7684 144.402 52.2572 144.42L51.8155 144.435C51.0152 144.463 50.5087 143.586 50.9328 142.906L51.1668 142.531C51.4377 142.097 51.3375 141.529 50.9345 141.214L50.5864 140.942C49.9556 140.449 50.1315 139.451 50.8929 139.203L51.3132 139.066C51.7996 138.908 52.0882 138.408 51.982 137.908L51.8903 137.476C51.7242 136.692 52.5002 136.041 53.2428 136.341L53.6526 136.506C54.127 136.698 54.6693 136.5 54.9096 136.049L55.1173 135.659Z",
    fill: "#4DBB5F",
    stroke: "#4DBB5F",
    strokeWidth: 2
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2598 139L22.748 130.469H23.8086L22.3203 139H21.2598ZM23.457 139L24.9512 130.469H26.0117L24.5176 139H23.457ZM26.8848 133.896H20.7852V132.906H26.8848V133.896ZM26.4395 136.598H20.3457V135.613H26.4395V136.598ZM31.8125 130.451V139H30.125V132.396L28.0977 133.041V131.711L31.6309 130.451H31.8125Z",
    fill: "#C1C1C1"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M116.26 139L117.748 130.469H118.809L117.32 139H116.26ZM118.457 139L119.951 130.469H121.012L119.518 139H118.457ZM121.885 133.896H115.785V132.906H121.885V133.896ZM121.439 136.598H115.346V135.613H121.439V136.598ZM128.535 137.682V139H122.699V137.875L125.459 134.916C125.736 134.607 125.955 134.336 126.115 134.102C126.275 133.863 126.391 133.65 126.461 133.463C126.535 133.271 126.572 133.09 126.572 132.918C126.572 132.66 126.529 132.439 126.443 132.256C126.357 132.068 126.23 131.924 126.062 131.822C125.898 131.721 125.695 131.67 125.453 131.67C125.195 131.67 124.973 131.732 124.785 131.857C124.602 131.982 124.461 132.156 124.363 132.379C124.27 132.602 124.223 132.854 124.223 133.135H122.529C122.529 132.627 122.65 132.162 122.893 131.74C123.135 131.314 123.477 130.977 123.918 130.727C124.359 130.473 124.883 130.346 125.488 130.346C126.086 130.346 126.59 130.443 127 130.639C127.414 130.83 127.727 131.107 127.938 131.471C128.152 131.83 128.26 132.26 128.26 132.76C128.26 133.041 128.215 133.316 128.125 133.586C128.035 133.852 127.906 134.117 127.738 134.383C127.574 134.645 127.375 134.91 127.141 135.18C126.906 135.449 126.646 135.729 126.361 136.018L124.879 137.682H128.535Z",
    fill: "#C1C1C1"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 81V80C49.9477 80 49.5 80.4477 49.5 81H50.5ZM49.7929 107.707C50.1834 108.098 50.8166 108.098 51.2071 107.707L57.5711 101.343C57.9616 100.953 57.9616 100.319 57.5711 99.9289C57.1805 99.5384 56.5474 99.5384 56.1569 99.9289L50.5 105.586L44.8431 99.9289C44.4526 99.5384 43.8195 99.5384 43.4289 99.9289C43.0384 100.319 43.0384 100.953 43.4289 101.343L49.7929 107.707ZM78.5 80H50.5V82H78.5V80ZM49.5 81V107H51.5V81H49.5Z",
    fill: "#878787"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M143.5 81V80C144.052 80 144.5 80.4477 144.5 81H143.5ZM144.207 107.707C143.817 108.098 143.183 108.098 142.793 107.707L136.429 101.343C136.038 100.953 136.038 100.319 136.429 99.9289C136.819 99.5384 137.453 99.5384 137.843 99.9289L143.5 105.586L149.157 99.9289C149.547 99.5384 150.181 99.5384 150.571 99.9289C150.962 100.319 150.962 100.953 150.571 101.343L144.207 107.707ZM115.5 80H143.5V82H115.5V80ZM144.5 81V107H142.5V81H144.5Z",
    fill: "#878787"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 494,
    y: 69,
    width: 22,
    height: 24,
    fill: "white",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 492,
    y: 69,
    width: 26,
    height: 10,
    fill: "white",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 492,
    y: 83,
    width: 26,
    height: 10,
    fill: "white",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M513 73V75.21",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M513 87V89.21",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M509 73V75.21",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M509 87V89.21",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M505 73V75.21",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M505 87V89.21",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M501 87V89.21",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M497 87V89.21",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M499 76C500.105 76 501 75.1046 501 74C501 72.8954 500.105 72 499 72C497.895 72 497 72.8954 497 74C497 75.1046 497.895 76 499 76Z",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 443,
    y: 203,
    width: 30,
    height: 20,
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 458,
    cy: 212,
    r: 2,
    stroke: "#C1C1C1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 444.5,
    y1: 220.5,
    x2: 471.5,
    y2: 220.5,
    stroke: "#C1C1C1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 221,
    width: 2,
    height: 2,
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 441,
    y: 221,
    width: 2,
    height: 2,
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 443,
    y: 173,
    width: 30,
    height: 20,
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 458,
    cy: 182,
    r: 2,
    stroke: "#C1C1C1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 444.5,
    y1: 190.5,
    x2: 471.5,
    y2: 190.5,
    stroke: "#C1C1C1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 191,
    width: 2,
    height: 2,
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 441,
    y: 191,
    width: 2,
    height: 2,
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 537,
    y: 173,
    width: 30,
    height: 20,
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 552,
    cy: 182,
    r: 2,
    stroke: "#C1C1C1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 538.5,
    y1: 190.5,
    x2: 565.5,
    y2: 190.5,
    stroke: "#C1C1C1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 567,
    y: 191,
    width: 2,
    height: 2,
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 535,
    y: 191,
    width: 2,
    height: 2,
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M449 146L467 146L467 129.414C467 129.149 466.895 128.895 466.707 128.707L462.586 124.586C462.211 124.211 461.702 124 461.172 124L450 124C449.448 124 449 124.448 449 125L449 146Z",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M462 129L462 125L466 129L462 129Z",
    fill: "#C1C1C1",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M461 153V143H467V153L464 150L461 153Z",
    stroke: "#C1C1C1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M463.117 135.659C463.493 134.952 464.507 134.952 464.883 135.659L465.09 136.049C465.331 136.5 465.873 136.698 466.347 136.506L466.757 136.341C467.5 136.041 468.276 136.692 468.11 137.476L468.018 137.908C467.912 138.408 468.2 138.908 468.687 139.066L469.107 139.203C469.869 139.451 470.044 140.449 469.414 140.942L469.065 141.214C468.663 141.529 468.562 142.097 468.833 142.531L469.067 142.906C469.491 143.586 468.985 144.463 468.184 144.435L467.743 144.42C467.232 144.402 466.79 144.773 466.718 145.28L466.656 145.717C466.545 146.51 465.593 146.857 464.997 146.321L464.669 146.026C464.289 145.684 463.711 145.684 463.331 146.026L463.003 146.321C462.407 146.857 461.455 146.51 461.344 145.717L461.282 145.28C461.21 144.773 460.768 144.402 460.257 144.42L459.816 144.435C459.015 144.463 458.509 143.586 458.933 142.906L459.167 142.531C459.438 142.097 459.337 141.529 458.935 141.214L458.586 140.942C457.956 140.449 458.131 139.451 458.893 139.203L459.313 139.066C459.8 138.908 460.088 138.408 459.982 137.908L459.89 137.476C459.724 136.692 460.5 136.041 461.243 136.341L461.653 136.506C462.127 136.698 462.669 136.5 462.91 136.049L463.117 135.659Z",
    fill: "#4DBB5F",
    stroke: "#4DBB5F",
    strokeWidth: 2
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M429.26 139L430.748 130.469H431.809L430.32 139H429.26ZM431.457 139L432.951 130.469H434.012L432.518 139H431.457ZM434.885 133.896H428.785V132.906H434.885V133.896ZM434.439 136.598H428.346V135.613H434.439V136.598ZM439.812 130.451V139H438.125V132.396L436.098 133.041V131.711L439.631 130.451H439.812Z",
    fill: "#C1C1C1"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M458.5 81V80C457.948 80 457.5 80.4477 457.5 81H458.5ZM457.793 107.707C458.183 108.098 458.817 108.098 459.207 107.707L465.571 101.343C465.962 100.953 465.962 100.319 465.571 99.9289C465.181 99.5384 464.547 99.5384 464.157 99.9289L458.5 105.586L452.843 99.9289C452.453 99.5384 451.819 99.5384 451.429 99.9289C451.038 100.319 451.038 100.953 451.429 101.343L457.793 107.707ZM486.5 80H458.5V82H486.5V80ZM457.5 81V107H459.5V81H457.5Z",
    fill: "#878787"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 533.828,
    y1: 164,
    x2: 573.334,
    y2: 203.505,
    stroke: "#EF341E",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 531,
    y1: 203.172,
    x2: 570.505,
    y2: 163.666,
    stroke: "#EF341E",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 202.5,
    y1: -1.92065e-8,
    x2: 202.5,
    y2: 279,
    stroke: "#27282C",
    strokeOpacity: 0.1
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 405.5,
    y1: -1.92065e-8,
    x2: 405.5,
    y2: 279,
    stroke: "#27282C",
    strokeOpacity: 0.1
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0522 35H50.374L51.1577 32.4365H54.8857L55.6694 35H57.9985L54.3218 24.4312H51.7217L48.0522 35ZM52.9595 26.5405H53.0913L54.3804 30.7812H51.6631L52.9595 26.5405ZM59.6538 35H61.7925V23.8525H59.6538V35ZM64.0776 35H66.2163V23.8525H64.0776V35ZM72.0098 35.1685C74.4927 35.1685 75.9868 33.6011 75.9868 30.9717V30.957C75.9868 28.3496 74.4707 26.7603 72.0098 26.7603C69.5488 26.7603 68.0327 28.3569 68.0327 30.957V30.9717C68.0327 33.5938 69.5269 35.1685 72.0098 35.1685ZM72.0098 33.4912C70.8672 33.4912 70.2227 32.561 70.2227 30.9717V30.957C70.2227 29.3823 70.8745 28.4375 72.0098 28.4375C73.1377 28.4375 73.7969 29.3823 73.7969 30.957V30.9717C73.7969 32.561 73.145 33.4912 72.0098 33.4912ZM81.2822 35.1685C83.3843 35.1685 84.644 34.0405 84.8638 32.2827L84.8711 32.2388H82.8936L82.8789 32.2681C82.6885 33.0737 82.1685 33.4912 81.2896 33.4912C80.147 33.4912 79.5098 32.5903 79.5098 30.957V30.9424C79.5098 29.3311 80.1396 28.4375 81.2896 28.4375C82.2051 28.4375 82.7397 28.9502 82.8789 29.7339L82.8862 29.7485H84.8784V29.7266C84.688 27.9248 83.4209 26.7603 81.2822 26.7603C78.7554 26.7603 77.3345 28.291 77.3345 30.9424V30.957C77.3345 33.6377 78.7627 35.1685 81.2822 35.1685ZM88.7456 35.1245C89.8003 35.1245 90.6499 34.6777 91.0601 33.9307H91.1919V35H93.3013V29.4922C93.3013 27.771 92.0928 26.7603 89.9541 26.7603C87.9253 26.7603 86.5923 27.6978 86.4238 29.1113L86.4165 29.1772H88.394L88.4087 29.1479C88.5771 28.6719 89.0679 28.4009 89.8369 28.4009C90.7158 28.4009 91.1919 28.7964 91.1919 29.4922V30.1587L89.2437 30.2759C87.2368 30.3931 86.1162 31.2427 86.1162 32.6929V32.7075C86.1162 34.1724 87.2075 35.1245 88.7456 35.1245ZM88.2036 32.5757V32.561C88.2036 31.9751 88.6504 31.6309 89.5659 31.5723L91.1919 31.4697V32.063C91.1919 32.9126 90.4521 33.5645 89.4634 33.5645C88.7236 33.5645 88.2036 33.1909 88.2036 32.5757ZM98.7432 35.0293C99.1533 35.0293 99.5488 34.9854 99.8125 34.9341V33.3447C99.6074 33.3667 99.4609 33.3813 99.1826 33.3813C98.4575 33.3813 98.1499 33.0591 98.1499 32.334V28.5474H99.8125V26.936H98.1499V25.0098H95.9893V26.936H94.7441V28.5474H95.9893V32.8247C95.9893 34.3921 96.7803 35.0293 98.7432 35.0293ZM105.079 35.1685C107.437 35.1685 108.477 33.8062 108.726 32.7954L108.741 32.7222H106.749L106.727 32.7661C106.58 33.0737 106.06 33.5718 105.123 33.5718C103.987 33.5718 103.277 32.8027 103.255 31.4771H108.807V30.8105C108.807 28.3716 107.342 26.7603 104.991 26.7603C102.64 26.7603 101.138 28.4082 101.138 30.9717V30.979C101.138 33.5645 102.625 35.1685 105.079 35.1685ZM105.027 28.3643C105.958 28.3643 106.624 28.9648 106.756 30.1367H103.277C103.409 28.9941 104.097 28.3643 105.027 28.3643ZM114.637 35H116.753V28.2397H116.871L121.763 35H123.594V24.4312H121.478V31.1621H121.36L116.482 24.4312H114.637V35ZM129.498 35.1685C131.856 35.1685 132.896 33.8062 133.145 32.7954L133.16 32.7222H131.167L131.146 32.7661C130.999 33.0737 130.479 33.5718 129.542 33.5718C128.406 33.5718 127.696 32.8027 127.674 31.4771H133.226V30.8105C133.226 28.3716 131.761 26.7603 129.41 26.7603C127.059 26.7603 125.557 28.4082 125.557 30.9717V30.979C125.557 33.5645 127.044 35.1685 129.498 35.1685ZM129.446 28.3643C130.376 28.3643 131.043 28.9648 131.175 30.1367H127.696C127.828 28.9941 128.516 28.3643 129.446 28.3643ZM136.36 35H138.602L140.03 29.375H140.162L141.604 35H143.875L146.021 26.936H143.904L142.703 32.7734H142.571L141.15 26.936H139.114L137.701 32.7734H137.569L136.368 26.936H134.207L136.36 35Z",
    fill: "#27282C"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M249.97 35H252.182V26.2549H255.353V24.4312H246.798V26.2549H249.97V35ZM257.902 35.1245C258.957 35.1245 259.806 34.6777 260.216 33.9307H260.348V35H262.458V29.4922C262.458 27.771 261.249 26.7603 259.11 26.7603C257.082 26.7603 255.749 27.6978 255.58 29.1113L255.573 29.1772H257.55L257.565 29.1479C257.733 28.6719 258.224 28.4009 258.993 28.4009C259.872 28.4009 260.348 28.7964 260.348 29.4922V30.1587L258.4 30.2759C256.393 30.3931 255.272 31.2427 255.272 32.6929V32.7075C255.272 34.1724 256.364 35.1245 257.902 35.1245ZM257.36 32.5757V32.561C257.36 31.9751 257.807 31.6309 258.722 31.5723L260.348 31.4697V32.063C260.348 32.9126 259.608 33.5645 258.62 33.5645C257.88 33.5645 257.36 33.1909 257.36 32.5757ZM264.625 35H266.764V32.2974L267.35 31.6748L269.701 35H272.228L268.917 30.3564L272.016 26.936H269.591L266.896 30.1221H266.764V23.8525H264.625V35ZM276.637 35.1685C278.996 35.1685 280.036 33.8062 280.285 32.7954L280.299 32.7222H278.307L278.285 32.7661C278.139 33.0737 277.619 33.5718 276.681 33.5718C275.546 33.5718 274.835 32.8027 274.813 31.4771H280.365V30.8105C280.365 28.3716 278.9 26.7603 276.549 26.7603C274.198 26.7603 272.697 28.4082 272.697 30.9717V30.979C272.697 33.5645 274.184 35.1685 276.637 35.1685ZM276.586 28.3643C277.516 28.3643 278.183 28.9648 278.314 30.1367H274.835C274.967 28.9941 275.656 28.3643 276.586 28.3643ZM290.817 35.271C293.937 35.271 295.9 33.1323 295.9 29.7192V29.7046C295.9 26.2915 293.93 24.1602 290.817 24.1602C287.704 24.1602 285.727 26.2842 285.727 29.7046V29.7192C285.727 33.1323 287.675 35.271 290.817 35.271ZM290.817 33.396C289.074 33.396 287.982 31.9531 287.982 29.7192V29.7046C287.982 27.4634 289.096 26.0352 290.817 26.0352C292.531 26.0352 293.644 27.4634 293.644 29.7046V29.7192C293.644 31.9531 292.538 33.396 290.817 33.396ZM297.863 35H300.001V23.8525H297.863V35ZM305.092 35.1245C306.227 35.1245 307.084 34.6191 307.501 33.7476H307.633V35H309.772V23.8525H307.633V28.2251H307.501C307.099 27.3462 306.198 26.8042 305.092 26.8042C303.048 26.8042 301.818 28.3643 301.818 30.957V30.9717C301.818 33.5498 303.078 35.1245 305.092 35.1245ZM305.817 33.3521C304.689 33.3521 303.993 32.4585 303.993 30.9717V30.957C303.993 29.4849 304.689 28.5767 305.817 28.5767C306.945 28.5767 307.655 29.4849 307.655 30.9644V30.979C307.655 32.4585 306.952 33.3521 305.817 33.3521ZM315.529 35.1685C317.887 35.1685 318.927 33.8062 319.176 32.7954L319.191 32.7222H317.199L317.177 32.7661C317.03 33.0737 316.51 33.5718 315.573 33.5718C314.438 33.5718 313.727 32.8027 313.705 31.4771H319.257V30.8105C319.257 28.3716 317.792 26.7603 315.441 26.7603C313.09 26.7603 311.588 28.4082 311.588 30.9717V30.979C311.588 33.5645 313.075 35.1685 315.529 35.1685ZM315.478 28.3643C316.408 28.3643 317.074 28.9648 317.206 30.1367H313.727C313.859 28.9941 314.547 28.3643 315.478 28.3643ZM324.215 35.1685C326.281 35.1685 327.753 34.1284 327.753 32.5317V32.5244C327.753 31.3306 326.999 30.6567 325.387 30.3125L324.047 30.0269C323.212 29.8438 322.912 29.5947 322.912 29.1626V29.1553C322.912 28.6133 323.439 28.269 324.179 28.269C324.977 28.269 325.453 28.6719 325.57 29.104L325.578 29.1406H327.562V29.1113C327.475 27.8149 326.303 26.7603 324.186 26.7603C322.172 26.7603 320.824 27.771 320.824 29.2871V29.2944C320.824 30.5029 321.586 31.2573 323.124 31.5869L324.472 31.8726C325.292 32.0557 325.614 32.3267 325.614 32.7588V32.7734C325.614 33.3081 325.058 33.6597 324.237 33.6597C323.395 33.6597 322.904 33.3008 322.736 32.8027L322.721 32.7734H320.619L320.626 32.8027C320.78 34.187 322.025 35.1685 324.215 35.1685ZM332.807 35.0293C333.217 35.0293 333.612 34.9854 333.876 34.9341V33.3447C333.671 33.3667 333.524 33.3813 333.246 33.3813C332.521 33.3813 332.213 33.0591 332.213 32.334V28.5474H333.876V26.936H332.213V25.0098H330.053V26.936H328.808V28.5474H330.053V32.8247C330.053 34.3921 330.844 35.0293 332.807 35.0293ZM344.357 35.271C347.477 35.271 349.44 33.1323 349.44 29.7192V29.7046C349.44 26.2915 347.47 24.1602 344.357 24.1602C341.244 24.1602 339.267 26.2842 339.267 29.7046V29.7192C339.267 33.1323 341.215 35.271 344.357 35.271ZM344.357 33.396C342.614 33.396 341.522 31.9531 341.522 29.7192V29.7046C341.522 27.4634 342.636 26.0352 344.357 26.0352C346.071 26.0352 347.184 27.4634 347.184 29.7046V29.7192C347.184 31.9531 346.078 33.396 344.357 33.396ZM353.996 35.1685C355.146 35.1685 355.966 34.6338 356.332 33.7549H356.464V35H358.603V26.936H356.464V31.5942C356.464 32.6855 355.893 33.396 354.838 33.396C353.827 33.396 353.395 32.8027 353.395 31.6602V26.936H351.256V32.1509C351.256 34.0698 352.187 35.1685 353.996 35.1685ZM364.096 35.0293C364.506 35.0293 364.901 34.9854 365.165 34.9341V33.3447C364.96 33.3667 364.813 33.3813 364.535 33.3813C363.81 33.3813 363.502 33.0591 363.502 32.334V28.5474H365.165V26.936H363.502V25.0098H361.342V26.936H360.097V28.5474H361.342V32.8247C361.342 34.3921 362.133 35.0293 364.096 35.0293Z",
    fill: "#27282C"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M469.002 35H471.214V31.6675H473.36C475.586 31.6675 477.073 30.2319 477.073 28.0566V28.042C477.073 25.8667 475.586 24.4312 473.36 24.4312H469.002V35ZM472.818 26.1816C474.085 26.1816 474.832 26.8481 474.832 28.0493V28.064C474.832 29.2651 474.085 29.939 472.818 29.939H471.214V26.1816H472.818ZM478.897 35H481.036V30.4883C481.036 29.3457 481.805 28.6499 483.021 28.6499C483.35 28.6499 483.68 28.7012 484.002 28.7744V26.9067C483.79 26.8481 483.489 26.8042 483.204 26.8042C482.156 26.8042 481.424 27.3169 481.167 28.1885H481.036V26.936H478.897V35ZM488.821 35.1685C491.304 35.1685 492.798 33.6011 492.798 30.9717V30.957C492.798 28.3496 491.282 26.7603 488.821 26.7603C486.36 26.7603 484.844 28.3569 484.844 30.957V30.9717C484.844 33.5938 486.338 35.1685 488.821 35.1685ZM488.821 33.4912C487.679 33.4912 487.034 32.561 487.034 30.9717V30.957C487.034 29.3823 487.686 28.4375 488.821 28.4375C489.949 28.4375 490.608 29.3823 490.608 30.957V30.9717C490.608 32.561 489.957 33.4912 488.821 33.4912ZM494.615 35H496.753V30.3345C496.753 29.2432 497.354 28.5327 498.343 28.5327C499.354 28.5327 499.822 29.1333 499.822 30.2686V35H501.961V29.7852C501.961 27.8589 500.994 26.7603 499.2 26.7603C498.05 26.7603 497.251 27.3096 496.885 28.1812H496.753V23.8525H494.615V35ZM505.125 25.6982C505.784 25.6982 506.326 25.1709 506.326 24.5117C506.326 23.8452 505.784 23.3179 505.125 23.3179C504.466 23.3179 503.917 23.8452 503.917 24.5117C503.917 25.1709 504.466 25.6982 505.125 25.6982ZM504.048 35H506.187V26.936H504.048V35ZM513.101 35.1245C515.115 35.1245 516.375 33.5498 516.375 30.9717V30.957C516.375 28.3643 515.145 26.8042 513.101 26.8042C511.995 26.8042 511.094 27.3462 510.684 28.2251H510.552V23.8525H508.414V35H510.552V33.7476H510.684C511.102 34.6191 511.958 35.1245 513.101 35.1245ZM512.369 33.3521C511.241 33.3521 510.53 32.4585 510.53 30.979V30.9644C510.53 29.4849 511.248 28.5767 512.369 28.5767C513.497 28.5767 514.2 29.4849 514.2 30.957V30.9717C514.2 32.4585 513.504 33.3521 512.369 33.3521ZM519.202 25.6982C519.861 25.6982 520.403 25.1709 520.403 24.5117C520.403 23.8452 519.861 23.3179 519.202 23.3179C518.543 23.3179 517.994 23.8452 517.994 24.5117C517.994 25.1709 518.543 25.6982 519.202 25.6982ZM518.125 35H520.264V26.936H518.125V35ZM525.765 35.0293C526.175 35.0293 526.57 34.9854 526.834 34.9341V33.3447C526.629 33.3667 526.482 33.3813 526.204 33.3813C525.479 33.3813 525.171 33.0591 525.171 32.334V28.5474H526.834V26.936H525.171V25.0098H523.011V26.936H521.766V28.5474H523.011V32.8247C523.011 34.3921 523.802 35.0293 525.765 35.0293ZM532.1 35.1685C534.458 35.1685 535.499 33.8062 535.748 32.7954L535.762 32.7222H533.77L533.748 32.7661C533.602 33.0737 533.082 33.5718 532.144 33.5718C531.009 33.5718 530.298 32.8027 530.276 31.4771H535.828V30.8105C535.828 28.3716 534.363 26.7603 532.012 26.7603C529.661 26.7603 528.16 28.4082 528.16 30.9717V30.979C528.16 33.5645 529.646 35.1685 532.1 35.1685ZM532.049 28.3643C532.979 28.3643 533.646 28.9648 533.777 30.1367H530.298C530.43 28.9941 531.119 28.3643 532.049 28.3643ZM540.457 35.1245C541.592 35.1245 542.449 34.6191 542.867 33.7476H542.999V35H545.137V23.8525H542.999V28.2251H542.867C542.464 27.3462 541.563 26.8042 540.457 26.8042C538.414 26.8042 537.183 28.3643 537.183 30.957V30.9717C537.183 33.5498 538.443 35.1245 540.457 35.1245ZM541.182 33.3521C540.054 33.3521 539.358 32.4585 539.358 30.9717V30.957C539.358 29.4849 540.054 28.5767 541.182 28.5767C542.31 28.5767 543.021 29.4849 543.021 30.9644V30.979C543.021 32.4585 542.317 33.3521 541.182 33.3521Z",
    fill: "#27282C"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V-1H-1V0H0ZM608 0H609V-1H608V0ZM608 279V280H609V279H608ZM0 279H-1V280H0V279ZM0 1H608V-1H0V1ZM607 0V279H609V0H607ZM608 278H0V280H608V278ZM1 279V0H-1V279H1Z",
    fill: "#27282C",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirdMachinePopup);
export default __webpack_public_path__ + "static/media/third-machine-popup.d06625d3.svg";
export { ForwardRef as ReactComponent };